import { useInfiniteQuery, keepPreviousData } from '@tanstack/react-query';
import fetchTwilioMessages from 'app/services/twilio/messages';

export const queryKey = ['twilioMessages'];

export default function useTwilioMessages(enabled = false) {
  return useInfiniteQuery({
    queryKey,
    enabled,
    queryFn: ({ pageParam }) => fetchTwilioMessages(pageParam),
    placeholderData: keepPreviousData,
    initialPageParam: 0,
    getPreviousPageParam: (page) => {
      return page.hasPrevious ? 1 : null;
    },
    getNextPageParam: () => {
      return null;
    },
    staleTime: Infinity,
    select: (data) => {
      return {
        ...data,
        messages: data.pages.flatMap((page) => page.items),
      };
    },
  });
}
